const originalLog = console.log;
// console.log = (...args) => {};

type LogLevel = 'debug' | 'info' | 'warn' | 'error';
const colorMap: Record<LogLevel,string> = {
  debug: 'color: #888',
  info:  'color: #007acc',
  warn:  'color: #d9822b',
  error: 'color: #d32f2f',
};

export const createStoreLogger = (storeName: string) => {
  const prefix = `%c[Store:${storeName}]`;
  const log = (level: LogLevel, ...args: unknown[]) => {
    // console[level](prefix, colorMap[level], ...args);
  };
  return {
    debug: (...args: unknown[]) => log('debug', ...args),
    info:  (...args: unknown[]) => log('info',  ...args),
    warn:  (...args: unknown[]) => log('warn',  ...args),
    error: (...args: unknown[]) => log('error', ...args),
  };
};
